const tokenTypes = {
  JWT: "jwt",
  OAuth2: "id_token",
};
Object.freeze(tokenTypes);

export { tokenTypes };
